<template>
  <div
    v-if="form.length > 0"
    class="border border-gray-400 bg-white rounded p-6"
  >
    <div class="flex items-center justify-between pb-6">
      <h3 class="text-lg font-medium text-gray-900">{{ title }}</h3>
      <MainButton v-if="editable" title="Edit" blue small @click="edit" />
    </div>
    <p class="text-sm text-gray-700">
      Delete any duplicates before clicking submit.
    </p>

    <dl>
      <div class="grid grid-cols-3 col-gap-10 pt-6 border-t border-gray-400">
        <dt
          class="col-span-3 md:col-span-1 mb-4 md:mb-0 text-sm break-words leading-5 font-medium text-gray-700"
        >
          What do you want compensation for?
        </dt>

        <dd class="col-span-3 md:col-span-2 text-sm leading-5 text-gray-900">
          <div
            v-for="(compensation, i) in form"
            :key="compensation + i"
            class="first:mt-0 mt-4"
          >
            <ul
              class="border border-gray-400 rounded-md mb-4 last:mb-0 hover:bg-gray-200 duration-100"
            >
              <li class="grid grid-cols-2 gap-2 p-3 text-sm leading-5">
                <!-- Description -->
                <p
                  v-if="compensation.description"
                  class="font-medium text-gray-700"
                >
                  Description:
                </p>
                <p v-if="compensation.description">
                  {{ truncateDescription(compensation.description) }}
                </p>

                <!-- Amount -->
                <p
                  v-if="compensation.amount && compensation.currency"
                  class="font-medium text-gray-700"
                >
                  Amount:
                </p>
                <p>
                  <span v-if="compensation.amount" class="whitespace-no-wrap">
                    {{
                      compensation.amount
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                    }}
                  </span>
                  <span v-if="compensation.currency" class="text-xs">
                    {{ compensation.currency.slice(0, 3) }}
                  </span>
                </p>

                <template v-if="compensation.details">
                  <!-- Year of Purchase -->
                  <p
                    v-if="compensation.details.yearOfPurchase"
                    class="font-medium text-gray-700"
                  >
                    Year of purchase:
                  </p>
                  <p v-if="compensation.details.yearOfPurchase">
                    {{ compensation.details.yearOfPurchase }}
                  </p>

                  <!-- Is repairable? -->
                  <p
                    v-if="compensation.details.itemRepairable"
                    class="font-medium text-gray-700"
                  >
                    Is repairable?
                  </p>
                  <p v-if="compensation.details.itemRepairable">
                    {{ compensation.details.itemRepairable }}
                  </p>

                  <p
                    v-if="
                      compensation.details.repairAmount &&
                      compensation.details.repairCurrency
                    "
                    class="font-medium text-gray-700"
                  >
                    Repair cost:
                  </p>
                  <p
                    v-if="
                      compensation.details.repairAmount &&
                      compensation.details.repairCurrency
                    "
                    class="whitespace-no-wrap"
                  >
                    <span>
                      {{
                        compensation.details.repairAmount
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                      }}
                    </span>
                    <span>{{
                      compensation.details.repairCurrency.slice(0, 3)
                    }}</span>
                  </p>
                  <!-- Repair cost -->
                </template>

                <!-- File(s) -->
                <p class="font-medium text-gray-700">File(s):</p>
                <div>
                  <p
                    v-for="(file, idx) in compensation.files"
                    :key="idx"
                    :title="file.originalFileName"
                  >
                    {{ truncateFilename(file.originalFileName) }}
                  </p>
                  <p v-if="compensation && compensation.files.length < 1">
                    No attachments.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </dd>
      </div>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'CompensationSummary',
  props: {
    title: {
      type: String,
      default: null
    },
    form: {
      type: Array,
      default: null
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    truncateDescription(value) {
      const truncate = value.substring(0, 40) + '..';

      if (value.length > 40) {
        return truncate;
      }

      return value;
    },
    truncateFilename(filename) {
      const truncate =
        filename.split('.').slice(0, -1).join('.').substring(0, 15) +
        '...' +
        filename.split('.').pop();

      if (filename.length > 15) {
        return truncate;
      }

      return filename;
    },
    edit() {
      const bank = 'bank-details';
      const claim = 'provide-information';

      this.$router.push(this.title === 'Bank Details' ? bank : claim);

      this.scrollToTop();
    }
  }
};
</script>
